export class ReportFileModel {
  url: string;
}
